"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = _interopRequireDefault(require("./auth"));
var _cache = _interopRequireDefault(require("./cache"));
var _modal = _interopRequireDefault(require("./modal"));
var _download = _interopRequireDefault(require("./download"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  install: function install(Vue) {
    // 认证对象
    Vue.prototype.$auth = _auth.default;
    // 缓存对象
    Vue.prototype.$cache = _cache.default;
    // 模态框对象
    Vue.prototype.$modal = _modal.default;
    // 下载文件
    Vue.prototype.$download = _download.default;
  }
};